export const isJson = (fileName?: string) => fileName?.includes('json')
